import { FC, memo, ReactNode } from "react";
import clsx from "clsx";
import styles from "./GalaxyBanner.module.css";

import FallingStar1x from "./assets/falling-start-1.png";
import FallingStar2x from "./assets/falling-start-2.png";
import FallingStart from "./assets/falling-start.png";
import Moon from "./assets/moon.png";
import Galaxy from "./assets/galaxy.png";
import Mars from "./assets/mars.png";

const GalaxyBanner: FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <div className={clsx(styles.root, "f-center")}>
      <div className={styles.title}>
        {children || (
          <span>
            Join the world&apos;s <br /> best
            <span className={styles.orangeText}> hackathons</span> platform
          </span>
        )}
      </div>

      <div className={clsx(styles.decorator, "container")}>
        <img src={FallingStart} className={clsx(styles.decor, styles.star)} />
        <img src={Moon} className={clsx(styles.decor, styles.moon)} />
        <img src={Galaxy} className={clsx(styles.decor, styles.galaxy)} />
        <img src={FallingStar2x} className={clsx(styles.decor, styles.star2)} />
        <img src={FallingStar1x} className={clsx(styles.decor, styles.star1)} />
        <img src={Mars} className={clsx(styles.decor, styles.mars)} />
      </div>
    </div>
  );
};

export default memo(GalaxyBanner);
